import {useStore} from "vuex";
import {computed} from "vue";

export function pageGuid() {
    const store = useStore();
    const Guid = computed(function () {
        return store.state.pageGuid.data;
    });
    return {
        Guid
    }
}